function deepFreeze(value) {
    for (const child of Object.values(value)) {
        if (typeof child === 'object' && child !== null)
            deepFreeze(child);
    }
    return Object.freeze(value);
}
/** Inno Setup unattended install into {INSTALL_DIR}; GOG and most repack/ISO installers use it. */
const INNO_SILENT_ARGS = [
    '/VERYSILENT',
    '/SP-',
    '/SUPPRESSMSGBOXES',
    '/NORESTART',
    '/NOICONS',
    '/DIR={INSTALL_DIR}',
];
/** Deeply frozen and readonly: never mutate it, use {@link installTemplateSteps} for a copy. */
export const INSTALL_TEMPLATES = deepFreeze({
    repack_inno: [
        { type: 'extract' },
        { type: 'run_installer', path: 'setup.exe', args: INNO_SILENT_ARGS },
    ],
    // GOG ISOs ship `setup_<game>_<version>.exe`. When several files match, the client takes the
    // shallowest one and, within a depth, the first in case-insensitive name order, so a plain
    // `setup.exe` wins over `setup_x.exe`.
    iso_setup: [
        { type: 'extract' },
        { type: 'extract_iso', path: '*.iso' },
        { type: 'run_installer', path: 'setup*.exe', args: INNO_SILENT_ARGS },
    ],
    portable: [{ type: 'extract' }, { type: 'copy', from: '*', to: '.' }],
});
/** A fresh, mutable copy of a template's steps. */
export function installTemplateSteps(template) {
    return structuredClone(INSTALL_TEMPLATES[template]);
}
